import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getMaterialCityDetailReturn } from '../api/index.js';
export default {
  name: 'materialReturnSelectDrawer',
  props: {
    excludedIds: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    userId: {
      type: [String, Number],
      default: ''
    }
  },
  data: function data() {
    return {
      form: {
        code: '',
        material_id: '',
        name: '',
        refund_user_id: '',
        page: 1,
        pagesize: 20
      },
      materialTypeList: [{
        value: '3',
        label: '卡套'
      }, {
        value: '4',
        label: '券套'
      }, {
        value: '5',
        label: '手提袋'
      }, {
        value: '6',
        label: '宣传册'
      }, {
        value: '7',
        label: '画册'
      }],
      dataList: [],
      pages: {
        page: 1,
        pagesize: 20,
        totalCount: 0
      },
      selection: []
    };
  },
  created: function created() {
    this.form.refund_user_id = this.userId || '';
    this.getList();
  },
  methods: {
    getList: function getList() {
      var _this = this;
      getMaterialCityDetailReturn(this.form).then(function (res) {
        _this.dataList = res.data.list || [];
        _this.pages = res.pages || {};
      });
    },
    search: function search() {
      this.form.page = 1;
      this.getList();
    },
    reset: function reset() {
      this.$refs.form.resetFields();
      this.search();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.selection = val;
    },
    handleConfirm: function handleConfirm() {
      if (!this.selection.length) {
        this.$message.warning('请至少选择一个物料');
        return;
      }
      this.$emit('selected', this.selection);
    },
    handleClose: function handleClose() {
      this.$emit('close');
    },
    currentChange: function currentChange(val) {
      this.form.page = val;
      this.getList();
    },
    sizeChange: function sizeChange(val) {
      this.form.pagesize = val;
      this.form.page = 1;
      this.getList();
    }
  }
};